export const getDePseudonymed = (state) => state.persistStore.dePseudonymResults;